module.exports = __webpack_public_path__ + "static/media/chosen_carefully-grey.dc74311f.png";